import { render, staticRenderFns } from "./mediaPlatformTag.vue?vue&type=template&id=7a7e6c60&scoped=true&"
import script from "./mediaPlatformTag.vue?vue&type=script&lang=js&"
export * from "./mediaPlatformTag.vue?vue&type=script&lang=js&"
import style0 from "./mediaPlatformTag.vue?vue&type=style&index=0&id=7a7e6c60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7e6c60",
  null
  
)

component.options.__file = "mediaPlatformTag.vue"
export default component.exports